// src/pages/LoginPage.tsx

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import { LoginForm } from '../components/auth/LoginForm';
import { AppConfig } from '../config/app.config';

export const LoginPage: React.FC = () => {
  const { login, isLoading, error, clearError, isAuthenticated } = useAuthContext();
  const navigate  = useNavigate();
  const location  = useLocation();
  const from      = (location.state as any)?.from?.pathname || '/dashboard';

  React.useEffect(() => {
    if (isAuthenticated) navigate(from, { replace: true });
  }, [isAuthenticated, navigate, from]);

  const handleLogin = async (data: any) => {
    const ok = await login(data);
    if (ok) navigate(from, { replace: true });
    return ok;
  };

  return (
    <div className="lgt-layout">
      {/* Left — brand */}
      <aside className="lgt-panel lgt-panel--brand">
        <div className="lgt-panel__brand-content">
          <div className="lgt-logo">
            <svg className="lgt-logo__icon" viewBox="0 0 48 48" fill="none">
              <rect width="48" height="48" rx="12" fill="currentColor" fillOpacity="0.15"/>
              <path d="M10 34L18 14l8 12 6-8 6 16" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="38" cy="14" r="3" fill="currentColor"/>
            </svg>
            <span className="lgt-logo__name">{AppConfig.app.name}</span>
          </div>
          <h1 className="lgt-panel__headline">Gestión logística<br/><em>inteligente.</em></h1>
          <p className="lgt-panel__subtext">Monitorea, opera y analiza tu cadena de suministro desde un solo lugar.</p>
          <ul className="lgt-features">
            {[{ icon: '⚡', text: 'Tiempo real' }, { icon: '🔒', text: 'Acceso por roles' }, { icon: '📊', text: 'Dashboards operativos' }].map(f => (
              <li key={f.text} className="lgt-features__item">
                <span className="lgt-features__icon">{f.icon}</span>{f.text}
              </li>
            ))}
          </ul>
        </div>
        <div className="lgt-panel__grid" aria-hidden="true">
          {Array.from({ length: 24 }).map((_, i) => <div key={i} className="lgt-panel__cell" />)}
        </div>
      </aside>

      {/* Right — form */}
      <main className="lgt-panel lgt-panel--form">
        <div className="lgt-panel__form-content">
          <header className="lgt-form-header">
            <h2 className="lgt-form-header__title">Iniciar sesión</h2>
            <p className="lgt-form-header__subtitle">Accede con tus credenciales corporativas</p>
          </header>
          <LoginForm onSubmit={handleLogin} isLoading={isLoading} error={error} onClearError={clearError} />
        </div>
      </main>
    </div>
  );
};
